import { mainKeys } from '@constants/main_keys'
import { type MetricName } from '@shared_types/modbus_types'
import { initializeMetrics } from '@shared_utils/metric_utils'
import { getSunsetAndSunrise } from '@utils/time_utils'

import {
  LOAD_MAIN,
  LOAD_MAIN_POSITION,
  UPDATE_MAIN_AIR_TEMPERATURE,
  UPDATE_MAIN_AVG_SPEED,
  UPDATE_MAIN_DEPTH,
  UPDATE_MAIN_ECO_SCORE,
  UPDATE_MAIN_HEADING,
  UPDATE_MAIN_MAX_SPEED,
  UPDATE_MAIN_POSITION,
  UPDATE_MAIN_PRESSURE,
  UPDATE_MAIN_SEA_WATER_TEMPERATURE,
  UPDATE_MAIN_SPEED,
  UPDATE_MAIN_TOTAL_DISTANCE, UPDATE_MAIN_WIND_DIRECTION,
  UPDATE_MAIN_WIND_SPEED } from '../actions'

const initialState = initializeMetrics(mainKeys as MetricName[])

export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  switch (type) {
    case LOAD_MAIN:
    // @ts-expect-error leave as is
      return Object.assign({}, previousState, { ...payload })
    case UPDATE_MAIN_SPEED:
    case UPDATE_MAIN_HEADING:
    case UPDATE_MAIN_DEPTH:
    case UPDATE_MAIN_PRESSURE:
    case UPDATE_MAIN_WIND_SPEED:
    case UPDATE_MAIN_WIND_DIRECTION:
    case UPDATE_MAIN_AIR_TEMPERATURE:
    case UPDATE_MAIN_SEA_WATER_TEMPERATURE:
    case UPDATE_MAIN_TOTAL_DISTANCE:
    case UPDATE_MAIN_AVG_SPEED:
    case UPDATE_MAIN_MAX_SPEED:
    case UPDATE_MAIN_ECO_SCORE:
      return Object.assign({}, previousState, payload)
    case LOAD_MAIN_POSITION:
    case UPDATE_MAIN_POSITION: {
    // @ts-expect-error leave as is
      const position = payload.position || previousState.position
      return Object.assign({}, previousState, {
      // @ts-expect-error leave as is
        ...payload,
        ...getSunsetAndSunrise(position.value, position.timestamp)
      })
    }
    default:
      return previousState
  }
}
